module.exports = __webpack_public_path__ + "img/codelab.a51f80b8.svg";